/**
 * Type partagé des vues admin (id et label) + définition des 3 sections.
 *
 * Extrait pour ne pas dupliquer le type View dans App.tsx, Sidebar.tsx,
 * Layout.tsx, BottomNav.tsx. Un seul endroit à toucher quand on ajoute,
 * renomme ou supprime une route.
 *
 * Trois sections (cf. BRIEF_admin-refonte_v2_2026-05-28.md ajusté) :
 * - FOUNDERS : surfaces dédiées à la gestion des données founders
 *              (investors directory, programmes non-dilutifs, etc.)
 * - CONTENT  : contenu publié sur les deux sites (news, companies)
 * - COMMUN   : administration interne (dashboard, audit, settings)
 */

export type View =
  | 'investors-directory'
  | 'founders'
  | 'founders-inbox'
  | 'non-dilutive'
  | 'brick-pipeline'
  | 'veille'
  | 'templates'
  | 'leads'
  | 'email-funnels'
  | 'news'
  | 'quantum-companies'
  | 'dashboard'
  | 'activity'
  | 'settings';

export const VIEW_LABEL: Record<View, string> = {
  'investors-directory': 'Investors directory',
  founders: 'Founders',
  'founders-inbox': 'Founders inbox',
  'non-dilutive': 'Programmes non-dilutifs',
  'brick-pipeline': 'Brick pipeline',
  veille: 'Veille',
  templates: 'Templates',
  leads: 'Leads',
  'email-funnels': 'Email funnels',
  news: 'News',
  'quantum-companies': 'Quantum Companies',
  dashboard: 'Dashboard',
  activity: 'Activity log',
  settings: 'Settings',
};

export type SectionId = 'founders' | 'content' | 'commun';

export const SECTION_LABEL: Record<SectionId, string> = {
  founders: 'Founders',
  content: 'Content',
  commun: 'Commun',
};

/**
 * Liste ordonnée des views par section. C'est la source de vérité pour
 * la sidebar et la BottomNav.
 */
export const SECTION_VIEWS: Record<SectionId, View[]> = {
  founders: [
    'investors-directory',
    'founders',
    'founders-inbox',
    'non-dilutive',
    'brick-pipeline',
    'veille',
    'templates',
    'leads',
    'email-funnels',
  ],
  content: ['news', 'quantum-companies'],
  commun: ['dashboard', 'activity', 'settings'],
};

/**
 * Pour la BottomNav mobile, on ne peut pas mettre 14 tabs. On garde les 5
 * priorités d'usage le plus fréquent.
 *
 * Mise à jour 2026-05-28 (audit B2) : ajout des 2 routes founders
 * prioritaires (Investors directory, Programmes), Brick pipeline (suivi
 * éditorial visuel utile en mobilité), Founders, News. Dashboard et
 * Settings retirés du tab bar car consultation rare en mobile (accessibles
 * via ⌘K sur desktop, ou via la sidebar repliée sur tablet).
 */
export const MOBILE_VIEWS: View[] = [
  'investors-directory',
  'founders',
  'non-dilutive',
  'brick-pipeline',
  'news',
];
